import { render, staticRenderFns } from "./setProduction.vue?vue&type=template&id=115d60e8&scoped=true&"
import script from "./setProduction.vue?vue&type=script&lang=js&"
export * from "./setProduction.vue?vue&type=script&lang=js&"
import style0 from "./setProduction.vue?vue&type=style&index=0&id=115d60e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115d60e8",
  null
  
)

export default component.exports